module.exports = __webpack_public_path__ + "static/Lato-Black-94f4c35a79bf8a1d161100de13a5f9c0.woff2";